module.exports = __webpack_public_path__ + "img/spell_top.6f959507.png";